import { useLocalStorage } from "react-use";

import { useAbility } from "hooks/useAbility";

import type { PermissionObject } from "../../types";

export interface UseSidebarItem {
  itemId: string;
  permissions: PermissionObject[];
  permissionOneOf?: boolean;
  isDefaultOpen?: boolean;
  isGroup?: boolean;
}

export function useSidebarItem({
  itemId,
  permissions,
  permissionOneOf,
  isDefaultOpen = false,
}: UseSidebarItem) {
  const ability = useAbility();

  const permissionsArray = permissions.map((permission) =>
    ability.can(permission.do, permission.on)
  );
  const hasAccess = permissionOneOf
    ? permissionsArray.some((can) => can)
    : permissionsArray.every((can) => can);

  const [isGroupOpen, setIsGroupOpen] = useLocalStorage(
    `isOpen-${itemId}`,
    isDefaultOpen
  );

  return { hasAccess, isGroupOpen, setIsGroupOpen };
}
